import { FC, useCallback, ChangeEventHandler } from 'react'
import { set } from 'monolite'

import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import TextField from '@mui/material/TextField'

import { PROGRAM_CARD_SLUG } from 'pages/single-program/constants'

import { ImageField } from 'common/ImageField'
import { ExtendedFileType } from 'common/DropImage'
import { base64ToFile } from 'utils/base64ToFile'

import {
  TITLE,
  TEXT,
  REF_LINK,
} from "./constants"

import type { StepViewProps } from '../../types'

import { ProgramCardData } from './interfaces'

export interface ProgramCardProps extends StepViewProps<typeof PROGRAM_CARD_SLUG> {}

export const ProgramCard: FC<ProgramCardProps> = ({ value: values, slug, onChange }) => {
  const handleImg = useCallback((newValue: ExtendedFileType) => {
    if (newValue) {
      const file = base64ToFile(newValue.base64, newValue.name, newValue.type)
      file
        .then((img) => {
          const newValues = {...values}
          // @ts-ignore
          newValues.image = img
          newValues.image_path = newValue.base64
          onChange(set(values, (_) => _, newValues), slug)
        })
        .catch((error) => console.log(error))
    }
  }, [values, slug, onChange])

  const handleDelete = useCallback(() => {
    onChange(set(values, (_) => _, {
      ...values,
      'image': null,
      'image_path': ''
    }), slug)
  }, [values, slug, onChange])

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>>(
    (event) => {
      onChange(
        set(values, (_) => _[event.target.name as keyof ProgramCardData], event.target.value),
        slug
      )
    },
    [values, slug, onChange]
  )

  return (
    <>
      <Typography component="h2" variant="h4">
        Program card
      </Typography>
      <Divider sx={{ mx: { xs: -2, md: -3 }, my: { xs: 2, md: 3 } }} />
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <ImageField
            imgUrl={values.image_path}
            handleImg={handleImg}
            handleDelete={handleDelete}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name={`${TITLE}`}
            label="Title"
            fullWidth
            variant="standard"
            value={values[TITLE]}
            onChange={handleChange}
          />
          <TextField
            name={`${TEXT}`}
            label="Text"
            fullWidth
            variant="standard"
            multiline
            rows={2}
            value={values[TEXT]}
            onChange={handleChange}
          />
          <TextField
            name={`${REF_LINK}`}
            label="Referral link"
            fullWidth
            variant="standard"
            value={values[REF_LINK]}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </>
  )
}
